import { createSlice, current, PayloadAction } from '@reduxjs/toolkit';
import { PAGELENGTH } from 'components/common/ListLayout';
import Api from "services/api"


export const initialState = {
  interpreter: [],
  error: null,
  singleInterpreter: null,
  loader: false,
  featured: {},
  total: 0,
  is_more: false,
  last_page: 1,
  featuredInterpreters: [],
  current_page: 1,
  per_page: PAGELENGTH,
  agreementAnalytics: {
    expired_agreements_count: 0,
    expiring_soon_count: 0,
  },
}
// interpreterSlice.js (top par)
const toArray = (value) => {
  if (Array.isArray(value)) return value;
  if (value && typeof value === 'object') {
    // paginator object aaye: { data: [...] }
    if (Array.isArray(value.data)) return value.data;
    // { "0": {...}, "1": {...} } jaisa object aaye
    return Object.values(value);
  }
  return [];
};

export const interpreterSlice = createSlice({
  name: 'interpreter',
  initialState: initialState,
  reducers: {
    setFeaturedInterpreters: (state, { payload }) => {
      state.featuredInterpreters = payload?.data ?? payload;
      state.total = payload?.total;
      state.is_more = payload?.is_more;
      state.last_page = payload?.last_page;
      state.current_page = payload?.current_page;
      state.per_page = payload?.per_page;
    },
    setInterpreters: (state, { payload }) => {
      // const pagination = payload?.data ?? payload;
      // state.interpreter = pagination?.data;
      const pagination = payload?.data && !Array.isArray(payload.data)
        ? payload.data
        : payload;
      state.interpreter = Array.isArray(payload?.data)
        ? payload.data
        : Array.isArray(pagination?.data)
          ? pagination.data
          : [];
      state.total = pagination?.total;
      state.is_more = pagination?.is_more;
      state.last_page = pagination?.last_page;
      state.current_page = pagination?.current_page;
      state.per_page = pagination?.per_page;
      state.agreementAnalytics = payload?.agreement_analytics ?? state.agreementAnalytics;
    },
    setMoreInterpreters: (state, { payload }) => {
      state.data = state.data.concat(payload.data);
      state.total = payload.total;
      state.is_more = payload.is_more;
      state.last_page = payload?.last_page;
      state.current_page = payload?.current_page;
      state.per_page = payload?.per_page;
    },
    removeInterpreter: (state, { payload }) => {
      state.error = payload
    },
    clearAllInterpreter: (state, { payload }) => {
      state.loader = payload
    },
    setError: (state, { payload }) => {
      state.error = payload
    },
    setLoader: (state, { payload }) => {
      state.loader = payload
    },
    setSingleInterpreter: (state, { payload }) => {
      state.singleInterpreter = payload;
    },
  }
})

export const addInterpreter = (data, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.addInterpreter(data)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // dispatch(setInterpreter(json.data))
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
}

export const updateInterpreter = (data, itemId, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.updateInterpreter(data, itemId)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // dispatch(setInterpreter(json.data))
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
}

export const removeInterpreter = (itemId, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.removeInterpreter(itemId)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // dispatch(setInterpreter(json.data))
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
}

export const fetchInterpreters = (page, params, disableLoader, Aync) => async (dispatch) => {
  const apiService = new Api();
  !disableLoader && dispatch(setLoader(true))
  try {

    const result = await Api.fetchInterpreters(page, params)
    if (result.status >= 200 && result.status < 300) {
      if (page > 1) {
        if (Aync) {
          return result?.data?.data?.data;
        } else {
          dispatch(setInterpreters({
            data: result.data.data.data,
            agreement_analytics: result.data.data.agreement_analytics,
          }));
          !disableLoader && dispatch(setLoader(false))
        }
      } else {
        if (Aync) {
          return result?.data?.data?.data;
        } else {
          dispatch(setInterpreters({
            data: result.data.data.data,
            agreement_analytics: result.data.data.agreement_analytics,
          }));
          !disableLoader && dispatch(setLoader(false))
        }
      }
    }
    else if (result?.status == 422) {
      if (Aync) {
        return [];
      } else {
        dispatch(setError(result.data))
        !disableLoader && dispatch(setLoader(false))
      }
    }
  } catch (error) {
    console.log("error", error)
  }
}

export const fetchInterpretersList = (page, params, disableLoader, Aync) => async (dispatch) => {
  const apiService = new Api();
  !disableLoader && dispatch(setLoader(true))
  try {

    const result = await Api.fetchAppointmentInterpretersList(page, params)
    if (result.status >= 200 && result.status < 300) {
      if (page > 1) {
        if (Aync) {
          return result?.data?.data;
        } else {
          dispatch(setInterpreters(result.data.data));
          !disableLoader && dispatch(setLoader(false))
        }
      } else {
        if (Aync) {
          return result?.data?.data;
        } else {
          dispatch(setInterpreters(result.data.data));
          !disableLoader && dispatch(setLoader(false))
        }
      }
    }
    else if (result?.status == 422) {
      if (Aync) {
        return [];
      } else {
        dispatch(setError(result.data))
        !disableLoader && dispatch(setLoader(false))
      }
    }
  } catch (error) {
    console.log("error", error)
  }
}


export const changeStatus = (id, data) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.statusChange(id, data, "interpreters")
    if (json.status >= 200 && json.status < 300) {
      // console.log(json)
      // dispatch(setHospital(json.data))
      // callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      // callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
}

export const removeMultipleInterpreters = (ids, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.removeMultipleInterpreters(ids)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // dispatch(setHospital(json.data))
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
};

export const fetchAvailableInterpreters = (params, disableLoader) => async (dispatch) => {
  !disableLoader && dispatch(setLoader(true))
  try {

    const result = await Api.fetchAvailableInterpreters(params)
    if (result.status >= 200 && result.status < 300) {
      dispatch(setFeaturedInterpreters(result.data));

    }
    else if (result?.status == 422) {
      dispatch(setError(result.data))
    }
  } catch (error) {
    console.log("error", error)

  }
  !disableLoader && dispatch(setLoader(false))

  dispatch(setLoader(false))
}


export const fetchExternalInterpreters = (page, params, disableLoader, Aync) => async (dispatch) => {
  const apiService = new Api();
  !disableLoader && dispatch(setLoader(true))
  try {

    const result = await Api.fetchExternalInterpreters(page, params)
    if (result.status >= 200 && result.status < 300) {
      if (page > 1) {
        if (Aync) {
          return result?.data?.data;
        } else {
          dispatch(setInterpreters(result.data.data));
          !disableLoader && dispatch(setLoader(false))
        }
      } else {
        if (Aync) {
          return result?.data?.data;
        } else {
          dispatch(setInterpreters(result.data.data));
          !disableLoader && dispatch(setLoader(false))
        }
      }
    }
    else if (result?.status == 422) {
      if (Aync) {
        return [];
      } else {
        dispatch(setError(result.data))
        !disableLoader && dispatch(setLoader(false))
      }
    }
  } catch (error) {
    console.log("error", error)
  }
}

// export const fetchExternalInterpreters = async (params) => {
//   try {
//     const result = await Api.fetchExternalInterpreters(params);

//     if (result && result.status >= 200 && result.status < 300) {
//       return result.data?.data || []; 
//     } else {
//       console.error("Error fetching external interpreters:", result?.data || result);
//       return [];
//     }
//   } catch (error) {
//     console.error("Network error fetching external interpreters:", error);
//     return [];
//   }
// };

export const getInterpreterById = (id) => async (dispatch) => {
  dispatch(setLoader(true));
  dispatch(setError(null));

  try {
    const response = await Api.getInterpreterById(id);

    if (response.status >= 200 && response.status < 300) {
      dispatch(setSingleInterpreter(response.data.data));
    }
    else if (response.status === 422) {
      dispatch(setError(response.data));
    }
  }
  catch (error) {
    console.log("error", error);
    dispatch(setError(error));
  }

  dispatch(setLoader(false));
};

export const generateCredentials = () => async (dispatch) => {
  dispatch(setLoader(true));
  dispatch(setError(null));

  try {
    const response = await Api.generateCredentials();

    if (response.status >= 200 && response.status < 300) {
      dispatch(setSingleInterpreter(response.data.data));
    }
    else if (response.status === 422) {
      dispatch(setError(response.data));
    }
  }
  catch (error) {
    console.log("error", error);
    dispatch(setError(error));
  }

  dispatch(setLoader(false));
};

export const addInterpreterChat = (id, callback) => async (dispatch) => {
  dispatch(setError({}));
  dispatch(setLoader(true));
  try {
    const response = await Api.addInterpreterChat(id);
    if (response.status >= 200 && response.status < 300) {
      callback(true, response.data.message);
    } else if (response.status === 422) {
      dispatch(setError(response.data));
      callback(false, response.data.message);
    } else {
      callback(false, response.data?.message || "Something went wrong");
    }
  } catch (error) {
    console.log(error);
    callback(false, "Network error");
  }
  dispatch(setLoader(false));
};

export const { setInterpreters, clearAllInterpreter, setLoader, setError, setMoreInterpreters, setFeaturedInterpreters, setSingleInterpreter } = interpreterSlice.actions


export default interpreterSlice.reducer
export const interpreterSelector = state => state.interpreter


